import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from "../../../../../../services/security/authentication.service";
import { RecordAction } from "../../../../../../utils/enums/shared/enums";
import { OperatorService } from "../../../../../../services/operator/operator.service";
import { Operator } from "../../../../../../utils/types/operator/operator.type";
import { CountryDatasource } from "../../../../../../utils/datasources/country/country.datasource";
import { CountryService } from "../../../../../../services/country/country.service";
import { ProtocolDatasource } from "../../../../../../utils/datasources/protocol/protocol.datasource";
import { ProtocolService } from "../../../../../../services/protocol/protocol.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "wtf-operator-form",
    templateUrl: "./operator-form.component.html",
    styleUrls: ["./operator-form.component.scss"],
    providers: [
        OperatorService,
        AuthenticationService,
        CountryDatasource,
        CountryService,
        ProtocolService,
        ProtocolDatasource,
    ],
    encapsulation: ViewEncapsulation.None,
})
export class OperatorFormComponent implements OnInit {
    operatorModel: Operator;
    dialogTitle: string;
    operatorForm: FormGroup;
    action: RecordAction;
    callback: (operator) => void;

    operators: any;
    countries: any = [];
    protocols: any = [];

    // presetColors = MatColors.presets;
    recordAction = RecordAction;
    datasource: CountryDatasource;

    constructor(
        public dialogRef: MatDialogRef<OperatorFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private service: OperatorService,
        private _datasource: CountryDatasource,
        private serviceCountry: CountryService,
        private datasourceProtocol: ProtocolDatasource,
        private serviceProtocol: ProtocolService,
        private translateService: TranslateService
    ) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.datasource = _datasource;

        this.operatorModel = data.operator;
        this.action = data.action;
        this.callback = data.callback;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.dialogTitle = this.operatorModel.name;
        } else {
            this.dialogTitle = "Nuevo Operador";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
            this.operatorModel = new Operator();
        }

        this.operatorForm = this.createForm();
    }

    ngOnInit() {
        this.datasource.getListInside().subscribe((res) => {
            this.countries = res.rows;
        });

        this.datasourceProtocol.getListInside().subscribe((res) => {
            this.protocols = res.rows;
        });
    }

    createForm() {
        const form = new FormGroup({
            name: new FormControl(this.operatorModel.name, [
                Validators.required,
                Validators.pattern(
                    "^[a-zA-ZñÑÀ-ú0-9_]+( [a-zA-ZñÑÀ-ú0-9_]+)*$"
                ),
            ]),
            active: new FormControl(Boolean(this.operatorModel.active)),
            msisdn_regex: new FormControl(this.operatorModel.msisdn_regex, [
                Validators.required,
            ]),
            msisdn_length: new FormControl(this.operatorModel.msisdn_length, [
                Validators.required,
                Validators.min(0),
            ]),
            start_window: new FormControl(this.operatorModel.start_window, [
                Validators.required,
            ]),
            end_window: new FormControl(this.operatorModel.end_window, [
                Validators.required,
            ]),
            id_country: new FormControl(this.operatorModel.id_country, [
                Validators.required,
            ]),
            protocolId: new FormControl(this.operatorModel.protocolId, [
                Validators.required,
            ]),
        });

        form.controls["name"].valueChanges.subscribe(
            (value) => (this.operatorModel.name = value)
        );
        form.controls["msisdn_regex"].valueChanges.subscribe(
            (value) => (this.operatorModel.msisdn_regex = value)
        );
        form.controls["msisdn_length"].valueChanges.subscribe(
            (value) => (this.operatorModel.msisdn_length = value)
        );
        form.controls["start_window"].valueChanges.subscribe(
            (value) => (this.operatorModel.start_window = value)
        );
        form.controls["end_window"].valueChanges.subscribe(
            (value) => (this.operatorModel.end_window = value)
        );
        form.controls["id_country"].valueChanges.subscribe(
            (value) => (this.operatorModel.id_country = value)
        );
        form.controls["protocolId"].valueChanges.subscribe(
            (value) => (this.operatorModel.protocolId = value)
        );
        form.controls["active"].valueChanges.subscribe(
            (value) => (this.operatorModel.active = value)
        );
        form.controls["id_country"].setValue(this.operatorModel.id_country);
        form.controls["protocolId"].setValue(this.operatorModel.protocolId);

        return form;
    }

    performAction() {
        if (this.operatorForm.invalid) {
            return;
        }

        for (const protocol of this.protocols) {
            if (protocol.id === this.operatorModel.protocolId) {
                this.operatorModel.protocol = protocol.name;
            }
        }

        this.callback(this.operatorModel);
    }
}
